import { render, staticRenderFns } from "./AnnotationLinkSelector.vue?vue&type=template&id=2db44e90&scoped=true"
import script from "./AnnotationLinkSelector.vue?vue&type=script&lang=js"
export * from "./AnnotationLinkSelector.vue?vue&type=script&lang=js"
import style0 from "./AnnotationLinkSelector.vue?vue&type=style&index=0&id=2db44e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db44e90",
  null
  
)

export default component.exports